import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    id: "alert-dialog",
    class: "alert-dialog"
};
const _hoisted_2 = { method: "dialog" };
const _hoisted_3 = {
    id: "alert-title",
    class: "title"
};
const _hoisted_4 = { class: "main-container" };
const _hoisted_5 = { class: "notice" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_start_screen = _resolveComponent("start-screen");
    const _component_create_game_form = _resolveComponent("create-game-form");
    const _component_load_game_form = _resolveComponent("load-game-form");
    const _component_game_home = _resolveComponent("game-home");
    const _component_player_home = _resolveComponent("player-home");
    const _component_spectator_home = _resolveComponent("spectator-home");
    const _component_game_end = _resolveComponent("game-end");
    const _component_games_overview = _resolveComponent("games-overview");
    const _component_card_list = _resolveComponent("card-list");
    const _component_admin_home = _resolveComponent("admin-home");
    const _component_login_home = _resolveComponent("login-home");
    const _component_help = _resolveComponent("help");
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass('topmost-' + _ctx.screen)
    }, [
        _createElementVNode("section", null, [
            _createElementVNode("dialog", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("Error with input", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("p", { id: "alert-dialog-message" }, null, -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("menu", { class: "dialog-menu centered-content" }, [
                        _createElementVNode("button", {
                            id: "alert-dialog-button",
                            class: "btn btn-lg btn-primary"
                        }, "OK")
                    ], -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            (_ctx.screen === 'start-screen')
                ? (_openBlock(), _createBlock(_component_start_screen, { key: 0 }))
                : (_ctx.screen === 'create-game-form')
                    ? (_openBlock(), _createBlock(_component_create_game_form, { key: 1 }))
                    : (_ctx.screen === 'load')
                        ? (_openBlock(), _createBlock(_component_load_game_form, { key: 2 }))
                        : (_ctx.screen === 'game-home' && _ctx.game !== undefined)
                            ? (_openBlock(), _createBlock(_component_game_home, {
                                key: 3,
                                game: _ctx.game
                            }, null, 8, ["game"]))
                            : (_ctx.screen === 'player-home' && _ctx.playerView !== undefined)
                                ? (_openBlock(), _createBlock(_component_player_home, {
                                    "player-view": _ctx.playerView,
                                    key: _ctx.playerkey
                                }, null, 8, ["player-view"]))
                                : (_ctx.screen === 'spectator-home' && _ctx.spectator !== undefined)
                                    ? (_openBlock(), _createBlock(_component_spectator_home, {
                                        spectator: _ctx.spectator,
                                        key: 'spectator-' + _ctx.playerkey
                                    }, null, 8, ["spectator"]))
                                    : (_ctx.screen === 'the-end')
                                        ? (_openBlock(), _createBlock(_component_game_end, {
                                            key: 6,
                                            "player-view": _ctx.playerView,
                                            spectator: _ctx.spectator
                                        }, null, 8, ["player-view", "spectator"]))
                                        : (_ctx.screen === 'games-overview')
                                            ? (_openBlock(), _createBlock(_component_games_overview, { key: 7 }))
                                            : (_ctx.screen === 'cards')
                                                ? (_openBlock(), _createBlock(_component_card_list, { key: 8 }))
                                                : (_ctx.screen === 'admin')
                                                    ? (_openBlock(), _createBlock(_component_admin_home, { key: 9 }))
                                                    : (_ctx.screen === 'login-home')
                                                        ? (_openBlock(), _createBlock(_component_login_home, { key: 10 }))
                                                        : (_ctx.screen === 'help')
                                                            ? (_openBlock(), _createBlock(_component_help, { key: 11 }))
                                                            : _createCommentVNode("", true)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Not affiliated with FryxGames, Asmodee Digital or Steam in any way. ", -1)
            ]))])), [
            [_directive_i18n]
        ])
    ], 2));
}
